import { Pipe, PipeTransform } from '@angular/core';
import { GraphQLComparision } from '../enums/GraphQLComparision.enum';

@Pipe({
  name: 'graphQLComparisionAsString'
})

export class GraphQLComparisionAsStringPipe implements PipeTransform {
  transform(value: number): any {
    return GraphQLComparision[value];
  }
}


